enum CouponType {
  CreditCard = 'credit_card',
  Code = 'code',
}

export default CouponType;
